<template>
  <div>
    <content-area :content="privacyPolicy"></content-area>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import contentArea from '@/components/content/content-area.vue';

export default {
  data() {
    return {
      privacyPolicy: []
    };
  },

  computed: {
    ...mapState({
      currentLanguage: 'currentLanguage'
    }),

    ...mapState('companyModule', {
      slug: 'slug'
    })
  },

  watch: {
    async slug() {
      this.privacyPolicy = await this.loadPrivacyPolicy(this.slug);
    },

    currentLanguage() {
      this.setHeroClaim([
        {
          languageKey: this.currentLanguage,
          translation: this.$t('privacyPolicy')
        }
      ]);
    }
  },

  async mounted() {
    this.setHeroClaim([
      {
        languageKey: this.currentLanguage,
        translation: this.$t('privacyPolicy')
      }
    ]);

    if (this.slug) {
      this.privacyPolicy = await this.loadPrivacyPolicy(this.slug);
    }
  },

  methods: {
    ...mapActions('companyModule', {
      loadPrivacyPolicy: 'loadPrivacyPolicy'
    }),

    ...mapMutations({
      setHeroClaim: 'setHeroClaim'
    })
  },

  components: {
    contentArea
  }
};
</script>
